import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePlanAccess } from '@/hooks/usePlanAccess';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';

export const PlanRouter: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { plan, loading } = usePlanAccess();
  
  if (loading) {
    return <LoadingSpinner message="Chargement..." />;
  }
  
  // Rediriger les utilisateurs du plan Stats vers /statistics
  if (plan === 'stats') {
    return <Navigate to="/statistics" replace />;
  }
  
  // Pour les autres plans (premium ou null), afficher le Dashboard
  return <>{children}</>;
};
